import GNB from './GNB';

export default GNB;
